import { SearchCard } from "components";

// Swiper Slider
import { Swiper, SwiperSlide } from "swiper/react";

export default function RecentSearch() {
  return (
    <div className="w-full flex flex-col mb-[40px] md:mb-[60px]">
      <div className="text-base md:text-2xl font-semibold text-black mb-4 md:mb-6">
        Recent Search
      </div>
      <div className="w-full flex">
        <Swiper
          slidesPerView={1.1}
          spaceBetween={16}
          style={{ width: "100%" }}
          breakpoints={{
            420: {
              slidesPerView: 1.1,
            },
            640: {
              slidesPerView: 2.2,
            },
            980: {
              slidesPerView: 2.6,
            },
          }}
        >
          {[...Array(6)].map((_, index) => (
            <SwiperSlide key={index}>
              <SearchCard key={index} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
